// extracted by mini-css-extract-plugin
export var searchHeader = "_8u-0";
export var searchHeaderDark = "_8u-1";